import React from "react";

import {
  FieldErrorText,
  FieldLabel,
  FormField,
  FormInput,
  FormSelect,
  PrimaryActionButton,
  SectionFormGrid,
} from "pages/app/workspace/sections/styles/workspace-section.styles";

type PaymentCreateFormProps = {
  amount: string;
  amountError?: string;
  isSubmitting: boolean;
  onAmountChange: (value: string) => void;
  onPaymentTypeChange: (value: "merchandise_item_id" | "player_class_id") => void;
  onSubmit: () => void;
  onTargetChange: (value: string) => void;
  paymentType: "merchandise_item_id" | "player_class_id";
  targetError?: string;
  targetId: string;
  targets: any[];
};

export const PaymentCreateForm: React.FC<PaymentCreateFormProps> = ({
  amount,
  amountError,
  isSubmitting,
  onAmountChange,
  onPaymentTypeChange,
  onSubmit,
  onTargetChange,
  paymentType,
  targetError,
  targetId,
  targets,
}) => (
  <SectionFormGrid>
    <FormField>
      <FieldLabel>Target type</FieldLabel>
      <FormSelect
        onChange={(event) =>
          onPaymentTypeChange(event.target.value as "merchandise_item_id" | "player_class_id")
        }
        value={paymentType}
      >
        <option value="merchandise_item_id">Merchandise</option>
        <option value="player_class_id">Player class</option>
      </FormSelect>
    </FormField>

    <FormField>
      <FieldLabel>Target</FieldLabel>
      <FormSelect
        aria-invalid={Boolean(targetError)}
        onChange={(event) => onTargetChange(event.target.value)}
        value={targetId}
      >
        <option value="">Select a target</option>
        {targets.map((target: any) => (
          <option key={target.id} value={target.id}>
            {target.name || target.title}
          </option>
        ))}
      </FormSelect>
      {targetError ? <FieldErrorText>{targetError}</FieldErrorText> : null}
    </FormField>

    <FormField>
      <FieldLabel>Amount override</FieldLabel>
      <FormInput
        aria-invalid={Boolean(amountError)}
        min="0"
        onChange={(event) => onAmountChange(event.target.value)}
        placeholder="Optional amount"
        type="number"
        value={amount}
      />
      {amountError ? <FieldErrorText>{amountError}</FieldErrorText> : null}
    </FormField>

    <PrimaryActionButton disabled={!targetId || isSubmitting} onClick={onSubmit} type="button">
      {isSubmitting ? "Processing..." : "Create payment"}
    </PrimaryActionButton>
  </SectionFormGrid>
);
